import { useShallow } from "zustand/react/shallow";
import { useExplorerStore } from "../store";
import type { SearchComponent, WrapProps } from "../types";

export default function SearchWrap({
	component: Component,
}: WrapProps<SearchComponent>) {
	const props = useExplorerStore(
		useShallow(
			({ doSearch: onSearch, doSearchReset: onReset, activeSearch }) => ({
				onSearch,
				onReset,
				activeSearch,
			}),
		),
	);
	return <Component {...props} />;
}
